import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";
import { StyledTableRow } from "../../components/Table/Table";
import { formatDate } from "../../utils/date";
import Status from "../../components/Status/Status";
import DownloadButton from "../../components/DownloadButton/DownloadButton";
import { calculateSum } from "../../utils";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) => ({
  tableRow: {
    fontSize: `${typography.body.l.fontSize}!important`,
    [theme.breakpoints.up("md")]: {
      fontSize: `${typography.body.xl.fontSize}!important`
    }
  }
}));

export default function Row(props: { row: any }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const { row } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <StyledTableRow
        key={row.id}
        onClick={() => setOpen(!open)}
        sx={{ "& > *": { borderBottom: "unset" }, cursor: "pointer" }}
      >
        <TableCell size="small" width={20}>
          <IconButton aria-label="expand row" size="small">
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell className={classes.tableRow} align="center">
          {formatDate(row.created_at)}
        </TableCell>
        <TableCell className={classes.tableRow} align="center">
          {row.paid_at ? formatDate(row.paid_at) : null}
        </TableCell>
        <TableCell className={classes.tableRow} align="left">
          {row.customer.name}
        </TableCell>
        <TableCell className={classes.tableRow} align="center">
          <Status status={row.status} />
        </TableCell>
        <TableCell
          align="right"
          sx={{ ...typography.body.xlBold, color: semanticColors.text.primary }}
        >
          {new Intl.NumberFormat("pt-PT", {
            style: "currency",
            currency: "EUR"
          }).format(row.value)}
        </TableCell>
        <TableCell className={classes.tableRow} align="center">
          {row.urlReceipt && <DownloadButton url={row.urlReceipt} />}
        </TableCell>
      </StyledTableRow>
      {/* A plain TableRow, not StyledTableRow: the detail cell has to sit inside
          a row (a <td> straight under <tbody> is invalid), but it does not want
          the 54px height and 8px inset that StyledTableRow forces on its cells —
          that styling never reached this panel before. colSpan matches the seven
          columns above so the panel spans the full width. */}
      {open && (
        <TableRow>
          <TableCell colSpan={7} padding="none">
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: "20px 0" }}>
                <Table
                  size="small"
                  aria-label="purchases"
                  sx={{ width: "100%" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell width={"50%"}>
                        {t("chargesHistory.description")}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }} width={"5%"}>
                        {t("chargesHistory.quantity")}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }} width={"10%"}>
                        {t("chargesHistory.value")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.items.map((item: any, i: any) => (
                      <TableRow key={`${item.code}-${i}`}>
                        <TableCell component="th" scope="row">
                          {item.description}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {item.quantity}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {new Intl.NumberFormat("pt-PT", {
                            style: "currency",
                            currency: "EUR"
                          }).format(item.value)}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <b>{t("chargesHistory.total")}</b>
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        <b>{calculateSum(row.items, "quantity")}</b>
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        <b>
                          {new Intl.NumberFormat("pt-PT", {
                            style: "currency",
                            currency: "EUR"
                          }).format(calculateSum(row.items, "value"))}
                        </b>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
/*   */
